export default __webpack_public_path__ + "static/media/Hemkunskap8.36dc184a.jpeg";